import { render } from "./savedPageDownloadComponent.vue?vue&type=template&id=6acab0e5"
import script from "./savedPageDownloadComponent.vue?vue&type=script&lang=js"
export * from "./savedPageDownloadComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__